// src/app/_landing/components/HeroSection.tsx
"use client";

import Image from "next/image";
import { WalletAuthButton } from "@/components/WalletAuthButton";

export const HeroSection = () => {
  return (
    <section className="w-full px-4 lg:px-8 py-2">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Content */}
          <div className="text-left">
            <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Welcome to RHUNA
            </h1>
            <p className="text-lg lg:text-xl text-gray-300 mb-8 max-w-lg">
              A revolutionary WEB3 ecosystem designed to transform how event organizers, 
              celebrities, and fans interact.
            </p>
            <WalletAuthButton variant="white" />
          </div>

          {/* Right Side - Hero Image */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <Image
                src="https://pulsarmoney.b-cdn.net/rhuna/hero_image.png"
                alt="RHUNA Hero"
                width={500}
                height={500}
                className="object-contain"
                priority
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
